import { useEffect, useState } from "react";
import { FilePlus2, ChevronRight, CheckCircle2, XCircle } from "lucide-react";
import { call, compact, slug, date } from "@/lib/api";
import { Modal, TableToolbar, PageHeader } from "@/components/common";

export default function VariationOrdersPage({ toast, user }) {
  const [items, setItems] = useState([]);
  const [contracts, setContracts] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ contract_id:"", title:"", description:"", amount:0, days_extension:0, reason:"Permintaan client" });
  const load = () => call.get("/variation-orders").then(setItems);
  useEffect(() => { load(); call.get("/contracts").then(setContracts); }, []);
  const canDecide = ["owner","admin","pm"].includes(user.role);
  const submit = async () => {
    try { await call.post("/variation-orders", { ...form, amount: Number(form.amount), days_extension: Number(form.days_extension) }); setOpen(false); load(); toast("VO dibuat & masuk approval"); }
    catch (e) { toast(e.response?.data?.detail || "Gagal", "error"); }
  };
  const decide = async (id, decision) => {
    try { await call.post(`/variation-orders/${id}/decide`, { decision, comment: decision === "approve" ? "Approved" : "Rejected" }); load(); toast(decision === "approve" ? "VO disetujui — nilai kontrak & budget diperbarui" : "VO ditolak"); }
    catch (e) { toast(e.response?.data?.detail || "Gagal", "error"); }
  };
  const selected = contracts.find(c => c.id === form.contract_id);
  const approvedTotal = items.filter(v => v.status === "Approved").reduce((s, v) => s + v.amount, 0);
  return (
    <div>
      <PageHeader subtitle="Variation Order / addendum — saat disetujui otomatis menambah nilai kontrak dan budget proyek." />
      <section className="kpi-grid" style={{marginBottom:16}}>
        <div className="kpi-card dark"><div className="kpi-top"><span>Total VO</span></div><strong>{items.length}</strong><small><i /> {items.filter(v => v.status === "Pending").length} pending</small></div>
        <div className="kpi-card green"><div className="kpi-top"><span>Nilai VO Approved</span></div><strong>{compact(approvedTotal)}</strong><small><i /> Ditambahkan ke kontrak</small></div>
      </section>
      <TableToolbar count={items.length} filters={["Semua","Pending","Approved","Rejected"]} onAdd={() => setOpen(true)} addLabel="Ajukan VO" />
      <div className="panel data-panel">
        <div className="data-list">
          {items.length === 0 && <div className="empty-module" style={{border:0,padding:60}}><p>Belum ada variation order.</p></div>}
          {items.map((v, i) => (
            <div className="data-item" data-testid={`vo-item-${i}`} key={v.id}>
              <div className="data-main">
                <span className="row-icon"><FilePlus2 size={16} /></span>
                <div><b>{v.title}</b><small>{v.code} · {v.contract_code} · {v.project_name} · +{v.days_extension} hari · oleh {v.requester} · {date(v.created_at)}</small></div>
              </div>
              <div className="data-value">+{compact(v.amount)}</div>
              <span className={`status status-${slug(v.status)}`}>{v.status}</span>
              {v.status === "Pending" && canDecide ? (
                <div className="approval-actions">
                  <button className="approve-btn" data-testid={`vo-approve-${i}`} onClick={() => decide(v.id, "approve")}><CheckCircle2 size={13} /> Approve</button>
                  <button className="reject-btn" data-testid={`vo-reject-${i}`} onClick={() => decide(v.id, "reject")}><XCircle size={13} /> Reject</button>
                </div>
              ) : <ChevronRight size={16} />}
            </div>
          ))}
        </div>
      </div>
      {open && <Modal title="Ajukan Variation Order" subtitle="Perubahan lingkup kerja yang menambah nilai kontrak" onClose={() => setOpen(false)} onSubmit={submit} testid="vo-modal" submitLabel="Ajukan VO">
        <div className="form-grid">
          <label className="form-full">Kontrak<select required data-testid="vo-contract-select" value={form.contract_id} onChange={e => setForm({ ...form, contract_id: e.target.value })}>
            <option value="">Pilih kontrak</option>{contracts.map(c => <option key={c.id} value={c.id}>{c.code} · {c.project_name} · {compact(c.contract_value)}</option>)}
          </select></label>
          <label className="form-full">Judul VO<input required data-testid="vo-title-input" value={form.title} onChange={e => setForm({ ...form, title: e.target.value })} placeholder="Penambahan lapangan padel ke-2" /></label>
          <label>Nilai Tambahan (Rp)<input type="number" required data-testid="vo-amount-input" value={form.amount} onChange={e => setForm({ ...form, amount: e.target.value })} /></label>
          <label>Perpanjangan Waktu (hari)<input type="number" data-testid="vo-days-input" value={form.days_extension} onChange={e => setForm({ ...form, days_extension: e.target.value })} /></label>
          <label className="form-full">Alasan<select value={form.reason} onChange={e => setForm({ ...form, reason: e.target.value })}>
            {["Permintaan client","Perubahan desain","Kondisi lapangan","Regulasi / perizinan","Lainnya"].map(s => <option key={s}>{s}</option>)}
          </select></label>
          <label className="form-full">Deskripsi lingkup<textarea value={form.description} onChange={e => setForm({ ...form, description: e.target.value })} /></label>
        </div>
        {selected && <div className="chip" style={{marginTop:16}} data-testid="vo-preview">Nilai kontrak baru: {compact(selected.contract_value)} → <b>{compact(selected.contract_value + Number(form.amount || 0))}</b></div>}
      </Modal>}
    </div>
  );
}
